const patchedKey = '__salesmsg_dom_patched__'

export const patchBrowserExtensionDom = () => {
  if (patchedKey in window) return

  Object.defineProperty(window, patchedKey, { value: true })

  const originalRemoveChild = Node.prototype.removeChild

  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      console.warn(
        '[patchBrowserExtensionDom] removeChild: node is not a child of this parent — likely browser extension interference. Skipping.'
      )

      return child
    }

    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore

  Node.prototype.insertBefore = function <T extends Node>(node: T, ref: Node | null): T {
    if (ref && ref.parentNode !== this) {
      console.warn(
        '[patchBrowserExtensionDom] insertBefore: ref node is not a child of this parent — likely browser extension interference. Skipping.'
      )

      return node
    }

    return originalInsertBefore.call(this, node, ref) as T
  }
}
